export const router = [
  {
    path: "system",
    component: (resolve) => require(["./layout/Index.vue"], resolve),
    children: [
      {
        path: "personal",
        component: (resolve) =>
          require(["./basic-info/person/Index.vue"], resolve),
      },
      {
        path: "company",
        component: (resolve) =>
          require(["./basic-info/company/Index.vue"], resolve),
      },
      {
        path: "user",
        component: (resolve) =>
          require(["./organizational/user/Index.vue"], resolve),
      },
      {
        path: "role",
        component: (resolve) =>
          require(["./organizational/role/Index.vue"], resolve),
      },
      {
        path: "workgroup",
        component: (resolve) =>
          require(["./organizational/workgroup/Index.vue"], resolve),
      },
      {
        path: "loginTerminal",
        component: (resolve) =>
          require(["./login-terminal/Index.vue"], resolve),
      },
    ],
  },
];
